<template>
  <div v-if="content" class="grid-component">
    <!--<custom-title :content="content.title[0]"></custom-title>-->
    <div class="grid">
      <grid-item :index="i" :content="item" v-for="(item,i) in content.items" :key="item.uid"></grid-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
$gridItemSize: 300;
.grid-component {
  background-color: #fff;
  position: relative;
}
.grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-auto-flow: dense;
  grid-gap: 12px;
  padding: 0;
  margin: auto;
  width: $content-width;
  max-width:$max-width;
  padding: 12px 0;
}
@media screen and (min-width: 981px) {
  .grid {
    grid-auto-rows: #{$gridItemSize / 2}px;
  }
}
@media screen and (max-width: 980px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
    .grid-item {
      height: 250px;
    }
    .grid-item-info {
      height: 125px;
    }
  }
}
@media screen and (max-width: 576px) {
  .grid {
    .grid-item {
      height: 200px;
    }
    .grid-item-info {
      height: 125px;
    }
  }
}
</style>
